import basic from "@/data/forms/mixins/basic.js";
import char from "@/data/forms/mixins/char.js";
import stats from "@/data/forms/mixins/stats.js";
import role from "@/data/forms/mixins/role.js";

export default {
  mixins: [
    // eslint-disable-next-line
    basic,
    char,
    stats,
    role
  ],
  data() {
    return {
      valid: true
    };
  },
  methods: {
    generateRoleForm() {
      let k = this.roleForm;
      k.basic = this.formBasicSimple; // basic
      k.char = this.formCharRole; // characteristics
      k.user = this.roleUser;
      k.stats = this.formStatsItem; // references
      return k;
    },
    selectIconFromRole(u) {
      if (u === "Creator" || u === "Originator" || u === "Writer") {
        return "account_circle";
      } else if (u === "Approver" || u === "Focal" || u === "Assignee") {
        return "account_box";
      } else if (u === "Apprentice" || u === "Trainee") {
        return "person";
      } else if (u === "Custodian" || u === "Lead" || u === "Manager") {
        return "groups";
      } else if (u === "Estimator" || u === "Social" || u === "Planner") {
        return "person_add_alt";
      } else if (u === "Legal") {
        return "account_balance";
      } else if (u === "Superintendent") {
        return "manage_accounts";
      } else if (u === "Finance") {
        return "paid";
      } else if (u === "HSE") {
        return "health_and_safety";
      } else if (u === "Worker") {
        return "build_circle";
      } else if (u === "Technical" || u === "Expert") {
        return "engineering";
      } else if (
        u === "Investigator" ||
        u === "Supervisor" ||
        u === "Coordinator"
      ) {
        return "supervisor_account";
      } else {
        return "account_box";
      }
    }
  }
};
